<template>
  <base-table-wrapper>
    <template #top-buttons>
      <router-link
        tag="button"
        :to="{ name: 'EXCMTaskTypeCreate' }"
        class="btn btn-sm btn-primary mb-1 float-right"
      >
        {{$t('buttons.create')}}
      </router-link>
    </template>
    <template #filtering>
      <div>
        <button
          type="button"
          class="btn btn-sm btn-primary fa fa-filter float-right"
          v-b-tooltip.hover :title="$t('buttons.search')"
          v-b-toggle.tasktype_search_collapse>
        </button>
      </div>
      <div>
        <b-collapse id="tasktype_search_collapse" class="mt-2">
          <TaskTypeFiltering @addToSearchParams="setSearchParams($event)"></TaskTypeFiltering>
        </b-collapse>
      </div>
    </template>
    <template #body>
      <Loader v-if="isLoading"></Loader>
      <div v-else-if="!isLoading && items.length < 1">
        {{$t('views.excmtasktype.list.noTaskType')}}
      </div>
      <table v-else class="table table-sm table-hover">
        <thead>
        <tr>
          <th>{{$t('views.excmtasktype.list.table.title')}}</th>
          <th>{{$t('views.excmtasktype.form.idCasesType')}}</th>
          <th>{{$t('views.excmtasktype.form.idDefaultNextTask')}}</th>
        </tr>
        </thead>
        <tbody>
        <template  v-for="(item, index) in items">
        <tr :key="item['@id']" :style="index % 2 === 0 ? 'background-color: rgba(0, 0, 0, 0.05)' : ''">
          <td>
            <router-link :to="{name: 'EXCMTaskTypeUpdate', params: { id: item['@id'] }}">
            {{ item['title'] }}</router-link>
          </td>
          <td>
            <span v-if="item.idCasesType">{{ item.idCasesType.title }}</span>
          </td>
          <td>
            <span v-if="item.idDefaultNextTask">{{ item.idDefaultNextTask.title }}</span>
          </td>
          <td>
            <b-dropdown
              class="float-right"
              size="sm" variant="link"
              right text="Right align"
              toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <i class="fa fa-bars fa-lg"></i>
              </template>
              <b-dropdown-item
                @click="$router.push({name: 'EXCMTaskTypeUpdate', params: { id: item['@id'] }})">
                <i class="fa fa-edit fa-lg"></i>
                {{ $t('buttons.edit') }}
              </b-dropdown-item>
              <b-dropdown-item
                @click="duplicate(item)">
                <i class="fa fa-copy fa-lg"></i>
                {{ $t('buttons.duplicate') }}
              </b-dropdown-item>
              <b-dropdown-item>
                <i class="fas fa fa-file-archive fa-lg"></i>
                {{ $t('buttons.archive') }}
              </b-dropdown-item>
              <b-dropdown-item>
                <i class="fas fa fa-trash fa-lg"></i>
                {{ $t('buttons.delete') }}
              </b-dropdown-item>
            </b-dropdown>
            <button @click="expand(index)" class="float-right fa fa-handshake fa-lg btn btn-sm btn-link"></button>
          </td>
        </tr>
        <tr :key="item['@id'] + 'collapse'">
          <td class="p-0" colspan="5">
            <b-collapse :id="'task_types_collapse_'+index" v-model="item.expanded">
              <ListRolesForTaskType v-if="item.expanded" :task-type="item"></ListRolesForTaskType>
            </b-collapse>
          </td>
        </tr>
        </template>
        </tbody>
      </table>
      <pagination
        v-if="view"
        :view="view"
        @getPage="getPage($event)"
      ></pagination>
    </template>
  </base-table-wrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'
import Pagination from '../../Layout/Pagination'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import ApiService from '@/utils/ApiService'
import ListRolesForTaskType from '@/components/Dashboard/Views/excmtasktype/ListRolesForTaskType'
import addParamsToQuery from '@/utils/addParamsToQuery'
import TaskTypeFiltering from '@/components/Dashboard/Views/excmtasktype/components/TaskTypeFiltering'

export default {
  beforeCreate () {
    checkPagePermission('configuration', 'EXCMTaskTypeList')
  },

  components: {
    TaskTypeFiltering,
    ListRolesForTaskType,
    Loader,
    Pagination,
    BaseTableWrapper
  },

  computed: mapGetters({
    deletedItem: 'excmtasktype/del/deleted',
    error: 'excmtasktype/list/error',
    items: 'excmtasktype/list/items',
    isLoading: 'excmtasktype/list/isLoading',
    view: 'excmtasktype/list/view'
  }),

  data () {
    return {
      searchParams: {
        'groups[]': 'read-allowed-roles',
        sortByNextTasks: true
      }
    }
  },

  created () {
    this.getPage(addParamsToQuery('e_x_c_m_task_types', this.searchParams))
  },

  methods: {
    ...mapActions({
      getPage: 'excmtasktype/list/getItems'
    }),
    setSearchParams (params = {}) {
      this.searchParams = Object.assign(this.searchParams, params)
      this.getPage(addParamsToQuery('e_x_c_m_task_types', this.searchParams))
    },
    async duplicate (item) {
      const decision = await this.$Swal({
        title: this.$t('views.excmtasktype.list.table.duplicateQuestion') + ' "' + item.title + '" ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      })
      if (decision) {
        const response = await new ApiService(item['@id'] + '/duplicate').post({})
        if (response && response.status === 201) {
          this.getPage(addParamsToQuery('e_x_c_m_task_types', this.searchParams))
        }
      }
    },
    expand (expandIndex) {
      this.items.forEach((consent, index) => {
        if (index !== expandIndex) {
          consent.expanded = false
        }
      })
      this.items[expandIndex].expanded = !this.items[expandIndex].expanded
      this.$forceUpdate()
    }
  }
}
</script>
